class memoiFooter extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.detailElement = this.querySelectorAll('[data-component-footer-summary]');

        this.checkIfClose();
        this.addEventListeners();
    }

    checkIfClose() {
        if (memoiGlobalUtils.isMobile()) {
            this.closeAccordions();
        } else {
            this.openAccordions();
        }
    }

    closeAccordions() {
        this.detailElement.forEach((element) => element.removeAttribute('open'))
    }

    openAccordions() {
        this.detailElement.forEach((element) => {
            element.setAttribute('open', '');
        })
    }

    addEventListeners() {
        window.addEventListener('resize', _ => {
            this.checkIfClose;
        })
    }
}

customElements.define('memoi-footer', memoiFooter);